<template>
    <div class="user-not-found">
        <div class="user-not-found__wrapper">
            <h1>Oops!</h1>
            <p>
                It appears that you do not have sufficient permissions to log in to this platform.
                <br />
                Please click
                <a
                    target="_blank"
                    rel="noopener"
                    href="https://wppopenassemble-access-request-hogarth.ideas.aha.io/ideas/new"
                    ><strong>here</strong></a
                >
                to request access.
            </p>
        </div>
    </div>
</template>

<script lang="ts">
import meQuery from "@/apollo/queries/Me.gql";
import type { Me } from "@/store/modules/auth";
import type { Err } from "@/types/types";

export default {
    name: "UserNotFound",

    apollo: {
        me: {
            query: meQuery,
            pollInterval: 5000,
            fetchPolicy: "no-cache",
            result({ data, error }: { data: { me: Me }; error: Err }) {
                if (!error && data.me) {
                    this.$router.replace({ name: "Home" });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.user-not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 80vh;
    text-align: center;

    .user-not-found__wrapper {
        margin: 50px auto;
        text-align: center;

        h1 {
            font-size: 32px;
            margin-bottom: 25px;
        }

        p {
            font-size: 14px;
            margin: 10px 0;
        }
    }
}
</style>
